import "./App.css";
import background from "./images/background.jpg";

function App() {
	return (
		<div className='App'>
			<img src={background} className='hero-img' alt='hero' />
			<div className="button-container">
				<a
					className='link-button'
					href='https://www.amazon.com/dp/B0G6Y1GLVJ/ref=sr_1_1?crid=2UTE0G82XDQ59&dib=eyJ2IjoiMSJ9.cn3nzEehTkmqHEc2r5_iFvkp39jW0Hj2_GXBqEAHlyeGtreQxesUfx-nbi4F2RQh.fwwG78F5MwCa5Gw5vBJMpwmeBvLuqtEPDZqBWptJxiM&dib_tag=se&keywords=scales+rising+storm&qid=1765809128&sprefix=%2Caps%2C442&sr=8-1'
					target='_blank'
					rel='noopener noreferrer'
				>
					Order the book now!
				</a>
			</div>
		</div>
	);
}

export default App;
